export const LIMITE_ATIVAS = 8;
export const LIMITE_QUALIF = 5;

// Catálogo de perguntas disponíveis no fluxo de Perguntas Essenciais.
//
// Entradas com `spinField` preenchido são as 9 perguntas "essenciais SPIN"
// que a Lais sempre precisa responder antes de rodar a busca de imóveis.
// - `spinField`: chave usada pelo agente (lais-ai/src/agents/realestate/identity.js)
//   para mapear a pergunta ao campo_faltante do fluxo de qualificação.
// - `defaultScript`: texto padrão que a Lais usa para essa pergunta. O usuário
//   pode sobrescrever editando o campo `script` em cada instância da pergunta
//   dentro do workflow — o agente usa o script salvo (se houver), senão o default.
//
// ATENÇÃO: a lista de `spinField` precisa ficar sincronizada com
// lais-ai/src/agents/realestate/identity.js → CATALOG_TO_SPIN_FIELD.
// Alterar aqui exige alterar lá também (ou vice-versa).
export const CATALOGO = [
    // ─── Perguntas SPIN (essenciais pra busca) ────────────────────────
    {
        id: 'finalidade',
        titulo: 'Finalidade',
        descricao: 'Morar, investir ou alugar.',
        icon: 'mdi:bullseye-arrow',
        spinField: 'purpose',
        defaultScript: 'Voce quer comprar ou alugar?',
    },
    {
        id: 'destination',
        titulo: 'Destino (residencial/comercial)',
        descricao: 'Se o imóvel é para moradia ou uso comercial.',
        icon: 'mdi:swap-horizontal',
        spinField: 'destination',
        defaultScript: 'Residencial ou comercial?',
    },
    {
        id: 'tipo-imovel',
        titulo: 'Tipo de imóvel',
        descricao: 'Apartamento, casa, sobrado, comercial, etc.',
        icon: 'mdi:home-outline',
        spinField: 'type',
        defaultScript: 'Qual tipo de imovel? (casa, apartamento, galpao, loja...)',
    },
    {
        id: 'atividade',
        titulo: 'Atividade (comercial)',
        descricao: 'Para que tipo de atividade o imóvel comercial será usado.',
        icon: 'mdi:briefcase-outline',
        spinField: 'atividade',
        defaultScript: 'Para qual tipo de atividade? (oficina, escritorio, loja...)',
    },
    {
        id: 'regiao-interesse',
        titulo: 'Região / Bairro de interesse',
        descricao: 'Bairros ou regiões preferidos.',
        icon: 'mdi:map-marker-outline',
        spinField: 'bairro',
        defaultScript: 'Tem preferencia de bairro ou regiao?',
    },
    {
        id: 'metragem',
        titulo: 'Metragem mínima',
        descricao: 'Área útil mínima desejada.',
        icon: 'mdi:ruler-square',
        spinField: 'metragem',
        defaultScript: 'Precisa de metragem minima? (ex: 150m², 300m², 500m²)',
    },
    {
        id: 'orcamento',
        titulo: 'Faixa de orçamento',
        descricao: 'Valor máximo que o lead pode pagar.',
        icon: 'mdi:cash-multiple',
        spinField: 'price',
        defaultScript: 'Qual valor esta disposto a pagar?',
    },
    {
        id: 'quantidade-quartos',
        titulo: 'Quantidade de quartos',
        descricao: 'Número mínimo de dormitórios.',
        icon: 'mdi:bed-outline',
        spinField: 'quartos',
        defaultScript: 'Quantos quartos?',
    },
    {
        id: 'vaga-garagem',
        titulo: 'Vaga de garagem',
        descricao: 'Necessidade de vagas.',
        icon: 'mdi:car-outline',
        spinField: 'vagas',
        defaultScript: 'Precisa de garagem?',
    },

    // ─── Perguntas extras (enriquecimento CRM / locação / pós-busca) ───
    // Essas não têm spinField — não participam da qualificação para busca.
    // São coletadas como informação complementar para o corretor humano.
    { id: 'cpf', titulo: 'CPF no pré-atendimento', descricao: 'Coletar CPF antes de enviar ao corretor (análise de crédito).', icon: 'mdi:card-account-details-outline' },
    { id: 'tipo-garantia', titulo: 'Tipo de garantia', descricao: 'Fiador, seguro fiança, caução ou depósito.', icon: 'mdi:shield-key-outline' },
    { id: 'processo-locacao', titulo: 'Processo de locação', descricao: 'Confirmar se o lead conhece o processo de locação.', icon: 'mdi:clipboard-text-outline' },
    { id: 'prazo-mudanca', titulo: 'Prazo para mudança', descricao: 'Quando o lead precisa se mudar.', icon: 'mdi:calendar-clock' },
    { id: 'moradores', titulo: 'Número de moradores', descricao: 'Quantas pessoas irão morar no imóvel.', icon: 'mdi:account-group-outline' },
    { id: 'pets', titulo: 'Possui pets', descricao: 'Se o lead tem animais (importante para locação).', icon: 'mdi:paw-outline' },
    { id: 'bairro', titulo: 'Bairro específico', descricao: 'Bairro específico de interesse (complementa "Região / Bairro").', icon: 'mdi:map-outline' },
    { id: 'andar', titulo: 'Preferência de andar', descricao: 'Andar alto, baixo ou indiferente.', icon: 'mdi:office-building-outline' },
    { id: 'contato-preferencial', titulo: 'Canal de contato', descricao: 'WhatsApp, ligação, e-mail, etc.', icon: 'mdi:phone-outline' },
];

export const CATALOGO_BY_ID = CATALOGO.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
}, {});

// Lookup por spinField: usado em componentes que precisam identificar qual
// pergunta do catálogo representa cada campo SPIN.
export const CATALOGO_BY_SPIN_FIELD = CATALOGO.reduce((acc, item) => {
    if (item.spinField) acc[item.spinField] = item;
    return acc;
}, {});

// IDs de perguntas que participam do fluxo SPIN. Útil para decidir onde
// mostrar o editor de script na UI (só faz sentido para SPIN).
export const SPIN_CATALOG_IDS = new Set(
    CATALOGO.filter((item) => item.spinField).map((item) => item.id)
);
